import PropTypes from "prop-types";
import { ProductList } from "vino/components";

const Block = ({ attributes }) => {
	return <ProductList attributes={attributes} />;
};

Block.propTypes = {
	attributes: PropTypes.object,
};

export default Block;
